/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

// window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app',
// });

import { createApp } from 'vue';
import Application from './components/Application.vue';

import ApplicationV2 from './components/ApplicationV2.vue';

// Refresh Application
import RefreshApplication from './components/RefreshApplication.vue';

import ProcessedApplication from './components/ProcessedApplication.vue';
import VueApexCharts from "vue3-apexcharts";

import english from './translations/en.js';
import french from './translations/fr.js';

import { createI18n } from 'vue-i18n';

const i18n = createI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        en: english,
        fr: french
    },
    // turn off warning for messages that contain HTML
    warnHtmlMessage: false,
    warnHtmlInMessage: 'off'
});

createApp({
    components: {
        Application,
        ProcessedApplication,
        RefreshApplication,
        ApplicationV2,
    },
    setup() {
        const urlParams = new URLSearchParams(window.location.search);
        const preferredLang =  window.App.locale || urlParams.get('lang') || null;
        // console.log('window.App.locale');
        // console.log(window.App.locale);
        const locale = preferredLang || localStorage.getItem('lc-locale') || 'en';
        i18n.global.locale = locale;
        localStorage.setItem('lc-locale', locale);
    },
})
.use(VueApexCharts)
.use(i18n)
.mount('#app');
